// Central place for external links. Facebook = primary platform, TikTok = secondary.
export const LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61590556665715&sk=reels_tab",
  // TikTok profile — confirm this handle is the official account
  tiktok: "https://www.tiktok.com/@spiritadmin",
  contactEmail: "hello@spiritadmin.org",
};
